import { render, staticRenderFns } from "./workFlowManagement.vue?vue&type=template&id=cbd6b85c&scoped=true&"
import script from "./workFlowManagement.vue?vue&type=script&lang=js&"
export * from "./workFlowManagement.vue?vue&type=script&lang=js&"
import style0 from "./workFlowManagement.vue?vue&type=style&index=0&id=cbd6b85c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6b85c",
  null
  
)

export default component.exports